<template>
  <div class="device-setting-tip">
    <div class="back-wrap" @click="backClick">
      <div class="back-icon"></div>
      返回
    </div>
    <div class="big-wrap">
      <div class="wrap1">
        <div class="wrap1-a">
          <div class="info1">
            <img
              :src="device_icon2"
              alt="#"
              v-if="unbindItem.term.status == 1"
            />
            <img :src="device_icon1" alt="#" v-else />
            <div class="status status-off" v-if="unbindItem.term.status == 1">
              <div>离线</div>
            </div>
            <div class="status" v-else>
              <div>在线</div>
            </div>
          </div>
          <div class="info2">
            <div class="device-name" v-if="newName2">
              {{ newName2 }}
            </div>
            <div class="device-name" v-else>
              {{ unbindDevName }}
            </div>
            <div class="device-ip">{{ unbindItem.ip }}</div>
          </div>
          <div
            v-if="false"
            :class="{
              'visit-btn': true,
              'visit-btn-gray': unbindItem.term.status == 1,
            }"
            @click="visitClick()"
          >
            访问
          </div>
        </div>
        <div class="split-line"></div>
        <div class="wrap1-b">
          <div class="item-wrap">
            <div class="item-wrap1">
              <div class="text2">设备名称</div>
              <div class="text2">备注名</div>
              <div class="line"></div>
              <div class="text2">最后更新时间</div>
              <div class="text2">NAT类型</div>
              <div class="text2">运营商</div>
              <div class="text2">全天在线时长</div>
              <div class="line"></div>
            </div>
            <div class="item-wrap2">
              <div class="text3">{{ unbindDevName }}</div>
              <div
                class="text3 name-input-wrap"
                :class="{
                  'edit-icon': newName == '' && !isEdit,
                  'edit-icon2': newName != '' && !isEdit,
                }"
              >
                <input
                  type="text"
                  v-model="newName"
                  @blur="saveNewNameClick()"
                  ref="nameInput"
                  @focus="editNameClick"
                  :class="{ 'name-input-focus': isEdit }"
                />
              </div>
              <div class="line2"></div>
              <div class="text3">{{ last_time }}</div>
              <div class="text3">
                {{ nat && nat >= 0 ? nat : "-" }}
              </div>
              <div class="text3">{{ province }} {{ isp }}</div>
              <div class="text3">{{ online_minu }}</div>
            </div>
          </div>
        </div>
        <div class="my-unbind-btn" @click="unbindClick(1)">解绑设备</div>
      </div>
      <div class="wrap3">
        <div class="wrap3-text">设备端功能</div>
        <div class="wrap3-line"></div>
        <div class="wrap3-items">
          <div class="item item1">
            <div class="item-icon"></div>
            <div class="item-text">远控本机</div>
          </div>
          <div class="item">
            <div class="item-icon item-icon2"></div>
            <div class="item-text">发起唤醒</div>
          </div>
          <div class="item">
            <div class="item-icon item-icon3"></div>
            <div class="item-text">发起唤醒</div>
          </div>
          <div class="item item-later">
            <div class="item-icon item-icon4"></div>
            <div class="item-text">视频备份</div>
            <div class="later">
              <div class="later-text">敬请期待</div>
            </div>
          </div>
          <div class="item item-later">
            <div class="item-icon item-icon5"></div>
            <div class="item-text">文件备份</div>
            <div class="later">
              <div class="later-text">敬请期待</div>
            </div>
          </div>
        </div>
        <div class="wrap3-text wrap3-text2">支持工具</div>
        <div class="wrap3-line"></div>

        <div class="app-wrap app-wrap3">
          <div class="text-icon"></div>
          <div class="text1">相册备份{{ xcbf }}</div>
          <div class="text2">一键备份相册至本机</div>
          <div
            :class="{
              btn: true,
              'offline-btn': peerItem.term.status && peerItem.term.status == 1,
            }"
            @click="installXcbfClick"
            v-if="xcbf == -1"
          >
            {{
              peerItem.term.status && peerItem.term.status == 1
                ? "设备离线"
                : "开启"
            }}
          </div>

          <div class="btn2" v-if="xcbf == 6">
            <div class="text">正在开启...</div>
            <el-progress
              :text-inside="true"
              :stroke-width="31"
              :percentage="xcbfPercent"
              color="#BDDBFF"
            ></el-progress>
          </div>

          <div
            :class="{
              'btn3 btn-open': true,
              'offline-btn': peerItem.term.status && peerItem.term.status == 1,
            }"
            v-if="xcbf == 1"
            @click="openXcbfClick"
          >
            {{
              peerItem.term.status && peerItem.term.status == 1
                ? "设备离线"
                : "打开"
            }}
          </div>

          <div
            :class="{ 'btn3 btn-stop': true }"
            v-if="xcbf == 1 && !peerItem.term.status"
            @click="openXcbfClick"
          >
            已开启
            <div
              :class="{ icon: true, icon2: isShowXcbfUninstall }"
              @click.stop="arrowXcbfClick"
              v-if="!peerItem.term.status"
            ></div>
          </div>
          <div
            class="uninstall-btn"
            v-if="isShowXcbfUninstall"
            @click="uninstallXcbfClick"
          >
            停止
          </div>
          <div class="btn2" v-if="xcbf == 9">
            <div class="text">正在停止...</div>
            <el-progress
              :text-inside="true"
              :stroke-width="31"
              :percentage="xcbfPercent"
              color="#BDDBFF"
            ></el-progress>
          </div>
        </div>

        <div class="wrap3-line"></div>
        <div class="app-wrap app-wrap2">
          <div class="text-icon text-icon3"></div>
          <div class="text1">宽带提速</div>
          <div class="text2">闲置带宽赚积分</div>
          <div
            :class="{
              btn: true,
              'offline-btn': peerItem.term.status && peerItem.term.status == 1,
            }"
            @click="installKdtsClick"
            v-if="kdts == -1"
          >
            {{
              peerItem.term.status && peerItem.term.status == 1
                ? "设备离线"
                : "开启"
            }}
          </div>
          <div class="btn2" v-if="kdts == 6">
            <div class="text">正在开启...</div>
            <el-progress
              :text-inside="true"
              :stroke-width="31"
              :percentage="kdtsPercent"
              color="#BDDBFF"
            ></el-progress>
          </div>

          <div
            :class="{
              'btn3 btn-open': true,
              'offline-btn': peerItem.term.status && peerItem.term.status == 1,
            }"
            v-if="kdts == 1"
            @click="openKdtsClick"
          >
            {{
              peerItem.term.status && peerItem.term.status == 1
                ? "设备离线"
                : "打开"
            }}
          </div>

          <div
            :class="{ 'btn3 btn-stop': true }"
            v-if="kdts == 1 && !peerItem.term.status"
            @click="openKdtsClick"
          >
            已开启
            <div
              :class="{ icon: true, icon2: isShowKdtsUninstall }"
              @click.stop="arrowKdtsClick"
              v-if="!peerItem.term.status"
            ></div>
          </div>
          <div
            class="uninstall-btn"
            v-if="isShowKdtsUninstall"
            @click="uninstallKdtsClick"
          >
            停止
          </div>
          <div class="btn2" v-if="kdts == 9">
            <div class="text">正在停止...</div>
            <el-progress
              :text-inside="true"
              :stroke-width="31"
              :percentage="kdtsPercent"
              color="#BDDBFF"
            ></el-progress>
          </div>
        </div>
        <div class="wrap3-line"></div>
        <div class="app-wrap app-wrap1" v-if="pidInfo.cid != 123">
          <div class="text-icon text-icon2"></div>
          <div class="text1">小宝驿站{{ xbjf }}</div>
          <div class="text2">开一间小宝驿站，乐享积分收益。</div>
          <div
            :class="{
              btn: true,
              'offline-btn': peerItem.term.status && peerItem.term.status == 1,
            }"
            @click="installXbjfClick"
            v-if="xbjf == -1"
          >
            {{
              peerItem.term.status && peerItem.term.status == 1
                ? "设备离线"
                : "开启"
            }}
          </div>
          <div class="btn2" v-if="xbjf == 6">
            <div class="text">正在开启...</div>
            <el-progress
              :text-inside="true"
              :stroke-width="31"
              :percentage="xbjfPercent"
              color="#BDDBFF"
            ></el-progress>
          </div>

          <div
            :class="{
              'btn3 btn-open': true,
              'offline-btn': peerItem.term.status && peerItem.term.status == 1,
            }"
            v-if="xbjf == 1"
            @click.stop="openXbjfClick"
          >
            {{
              peerItem.term.status && peerItem.term.status == 1
                ? "设备离线"
                : "打开"
            }}
          </div>

          <div
            :class="{ 'btn3 btn-stop': true }"
            v-if="xbjf == 1 && !peerItem.term.status"
            @click.stop="openXbjfClick"
          >
            已开启
            <div
              :class="{ icon: true, icon2: isShowXbjfUninstall }"
              @click.stop="arrowXbjfClick"
              v-if="!peerItem.term.status"
            ></div>
          </div>
          <div
            class="uninstall-btn"
            v-if="isShowXbjfUninstall"
            @click="uninstallXbjsClick"
          >
            停止
          </div>
          <div class="btn2" v-if="xbjf == 9">
            <div class="text">正在停止...</div>
            <el-progress
              :text-inside="true"
              :stroke-width="31"
              :percentage="xbjfPercent"
              color="#BDDBFF"
            ></el-progress>
          </div>
        </div>
      </div>
    </div>

    <Message :myWidth="myWidth" :myHeight="myHeight" v-if="isShowAlert">
      <template v-slot:content>
        <div class="unbind-wrap" v-if="settingType == 1">
          <div class="close-btn" @click="hideAlertClick()"></div>
          <img :src="device_icon3" alt="#" />
          <div class="title">设备解绑提醒</div>
          <div class="text-wrap">
            <div class="text1">
              该设备已添加远程服务，解绑后将
              <div>无法使用远程服务。</div>
            </div>
          </div>
          <div class="btn1" @click="unbindClick(3)">继续解绑</div>
          <div class="btn2" @click="hideAlertClick()">取消</div>
        </div>
        <div class="unbind-wrap" v-if="settingType == 2">
          <div class="close-btn" @click="hideAlertClick()"></div>
          <img :src="device_icon3" alt="#" />
          <div class="title">设备解绑提醒</div>
          <div class="text-wrap">
            <div class="text1">
              该设备已开启收益模式，解绑后
              <div>会对收益产生影响哦！</div>
            </div>
          </div>
          <div class="btn1" @click="unbindClick(3)">继续解绑</div>
          <div class="btn2" @click="hideAlertClick()">取消</div>
        </div>
        <div class="unbind-wrap" v-if="settingType == 3">
          <div class="close-btn" @click="hideAlertClick()"></div>
          <img :src="device_icon3" alt="#" />
          <div class="title">确认解绑</div>
          <div class="text-wrap">
            <div class="text1">
              确认是否解绑以下设备?
              <div>
                设备名称：<span>{{ unbindDevName }}</span>
              </div>
            </div>
          </div>
          <div class="btn1" @click="doUnbindClick()">确认解绑</div>
          <div class="btn2" @click="hideAlertClick()">取消</div>
        </div>
        <div class="cache-clean-wrap" v-if="settingType == 4">
          <div class="close-btn" @click="hideAlertClick()"></div>
          <img :src="device_icon4" alt="#" />
          <div class="title">清除缓存</div>
          <div class="text-wrap">
            <div class="text1">
              小宝会自动清理过期缓存，手动清除
              <div>缓存会影响积分收益。</div>
            </div>
          </div>
          <div class="clean-btns">
            <div class="clean-btn-sure" @click="cacheCleanClick(6)">确定</div>
            <div class="clean-btn-cancel" @click="hideAlertClick()">取消</div>
          </div>
        </div>
        <div class="do-cache-clean-wrap" v-if="settingType == 5">
          <div class="close-btn" @click="hideAlertClick()"></div>
          <div class="title">清除缓存</div>
          <div class="text-wrap">
            <div class="img-wrap">
              <img :src="device_icon4" alt="#" />
            </div>
            <div class="text1">
              请确定要清除缓存的大小。（清除缓存将按照由旧到新的顺序清除）
            </div>
          </div>
          <div class="cache-clean-options">
            <div :class="{ active: size == 25 }" @click="sizeClick(25)">
              50G
            </div>
            <div
              class="text2"
              :class="{ active: size == 50 }"
              @click="sizeClick(50)"
            >
              100G
            </div>
            <div :class="{ active: size == 100 }" @click="sizeClick(100)">
              全部
            </div>
          </div>
          <div class="clear-cache-btn" @click="doCacheCleanClick()">
            清除缓存
          </div>
        </div>
        <div class="do-cache-clean-wrap" v-if="settingType == 6">
          <div class="close-btn" @click="hideAlertClick()"></div>
          <div class="title">清除缓存</div>
          <div class="cleaning-tips">正在清除缓存</div>
          <div class="cleaning-sub-tips">关闭窗口后将继续清理缓存</div>
          <div class="clear-cache-btn" @click="hideCacheCleanClick()">确定</div>
        </div>
      </template>
    </Message>

    <Tip v-if="tip" :tip="tip"></Tip>
  </div>
</template>

<script>
import Message from "./Message.vue";
import { mapActions } from "vuex";
import * as echarts from "echarts";
import Tip from "@/components/Tip.vue";

export default {
  components: {
    Message,
    Tip,
  },
  props: {
    unbindItem: Object,
    unbindDevName: String,
    peerid: String,
    peerItem: Object,
  },
  data: function () {
    return {
      device_icon1: require("../assets/home/node/device_setting1.svg"),
      device_icon2: require("../assets/home/node/device_setting2.svg"),
      device_icon3: require("../assets/home/node/device_setting3.svg"),
      device_icon4: require("../assets/home/node/device_setting4.svg"),
      myWidth: "369px",
      myHeight: "395px",
      settingType: 1, //1设备解绑弹框 2设备解绑弹框 3确认设备解绑弹框 4清除缓存弹框 5确认清除缓存弹框
      size: 25, //25清除50G		50清除100G		100清除全部
      cacheused: 0,
      switching: 0,
      isShowAlert: false, //是否显示弹框
      cacheleft: 0,
      isp: "-", //运营商
      last_time: "", //最后登录时间
      nat: -1,
      online_minu: "0小时0分",
      newName: "",
      newName2: "",
      isEdit: false,
      province: "",
      isCleaningCache: false,

      navItems: [1, 2],
      tip: "",
      loadingGif: require("../assets/home/node/loading.gif"),
      isLoading: false,
      kdtsPercent: 0,
      xbjfPercent: 0,
      xcbfPercent: 0,
      cur_pid: this.$route.params.cur_pid ? this.$route.params.cur_pid : "",
      pidInfo: {
        cid: 0,
        did: 0,
      },
      isNoBind: false,
      currentTab: 0,
      list: [], //设备列表
      // peerItem: {
      // 	term: {},
      // },
      isShowKdtsUninstall: false,
      isShowXbjfUninstall: false,
      isShowXcbfUninstall: false,
      kdts: 1, //已安装1 未安装-1安装又卸载了0  正在安装6	正在卸载9
      xbjf: 1, //已安装1 未安装-1安装又卸载了0
      xcbf: 1, //已安装1 未安装-1安装又卸载了0
    };
  },
  watch: {},
  methods: {
    ...mapActions([
      "limitget",
      "deviceBandwidth",
      "nodeDeviceInfo",
      "deviceName",
      "sendUserlog",

      "bindget",
      "readguideget",
      "readguideset",
      "points",
      "deviceInfo",
      "limitget",
      "limitset",
      "cacheclean",
      "userGrowthInfo",
      "miniappList",
      "miniappStatus",
    ]),
    backClick: function () {
      this.$router.back(-1);
    },

    installXcbfClick: function () {
      let _that = this;

      if (_that.peerItem.term.status == 1) {
        _that.tip = "设备已离线";

        setTimeout(function () {
          _that.tip = "";
        }, 1500);
        return;
      }

      _that.xcbf = 6;
      _that.xcbfPercent = 5;
      setTimeout(function () {
        _that.xcbfPercent = 15;
      }, 500);
      setTimeout(function () {
        _that.xcbfPercent = 90;
      }, 1500);
      setTimeout(function () {
        _that.xcbfPercent = 100;
      }, 2500);
      setTimeout(function () {
        _that.xcbf = 1;
      }, 2800);
      setTimeout(function () {
        _that.openXcbfClick();
      }, 3000);

      _that.miniappStatus([_that.peerid, "xcbf", 1, function (err, data) {}]);
    },
    openXcbfClick: function () {
      let _that = this;
      if (_that.peerItem.term.status == 1) {
        _that.tip = "设备已离线";

        setTimeout(function () {
          _that.tip = "";
        }, 1500);
        return;
      }
      let dev_name = _that.peerItem.term.comment
        ? _that.peerItem.term.comment
        : _that.peerItem.term.name
        ? _that.peerItem.term.name
        : _that.peerItem.peerid;
      let dev_ip = _that.peerItem.ip
        ? _that.$common.ipConvert(_that.peerItem.ip)
        : "";
      _that.$router.push({
        name: "ImageBackup",
        params: {
          cur_pid: _that.peerid,
          dev_name: dev_name,
          dev_ip: dev_ip,
        },
      });
    },
    arrowXcbfClick: function () {
      let _that = this;
      _that.isShowXcbfUninstall = !_that.isShowXcbfUninstall;
      _that.isShowXbjfUninstall = false;
      _that.isShowKdtsUninstall = false;
    },
    uninstallXcbfClick: function () {
      let _that = this;
      _that.xcbf = 9;
      _that.isShowXcbfUninstall = false;
      _that.miniappStatus([_that.peerid, "xcbf", 0, function (err, data) {}]);

      _that.xcbfPercent = 5;
      setTimeout(function () {
        _that.xcbfPercent = 15;
      }, 500);
      setTimeout(function () {
        _that.xcbfPercent = 90;
      }, 1500);
      setTimeout(function () {
        _that.xcbfPercent = 100;
      }, 2500);
      setTimeout(function () {
        _that.xcbf = -1;
      }, 2800);
    },

    installKdtsClick: function () {
      let _that = this;

      if (_that.peerItem.term.status == 1) {
        _that.tip = "设备已离线";

        setTimeout(function () {
          _that.tip = "";
        }, 1500);
        return;
      }

      _that.kdts = 6;
      _that.kdtsPercent = 5;
      setTimeout(function () {
        _that.kdtsPercent = 15;
      }, 500);
      setTimeout(function () {
        _that.kdtsPercent = 90;
      }, 1500);
      setTimeout(function () {
        _that.kdtsPercent = 100;
      }, 2500);
      setTimeout(function () {
        _that.kdts = 1;
      }, 2800);
      setTimeout(function () {
        _that.$router.push({
          name: "Kdts",
          params: { cur_pid: _that.peerid },
        });
      }, 3000);

      _that.miniappStatus([_that.peerid, "kdts", 1, function (err, data) {}]);
    },
    openKdtsClick: function () {
      let _that = this;
      if (_that.peerItem.term.status == 1) {
        _that.tip = "设备已离线";

        setTimeout(function () {
          _that.tip = "";
        }, 1500);
        return;
      }
      _that.$router.push({
        name: "Kdts",
        params: { cur_pid: _that.peerid },
      });
    },
    arrowKdtsClick: function () {
      let _that = this;
      _that.isShowKdtsUninstall = !_that.isShowKdtsUninstall;
      _that.isShowXbjfUninstall = false;
    },
    uninstallKdtsClick: function () {
      let _that = this;
      _that.kdts = 9;
      _that.isShowKdtsUninstall = false;
      _that.miniappStatus([_that.peerid, "kdts", 0, function (err, data) {}]);

      _that.kdtsPercent = 5;
      setTimeout(function () {
        _that.kdtsPercent = 15;
      }, 500);
      setTimeout(function () {
        _that.kdtsPercent = 90;
      }, 1500);
      setTimeout(function () {
        _that.kdtsPercent = 100;
      }, 2500);
      setTimeout(function () {
        _that.kdts = -1;
      }, 2800);
    },

    installXbjfClick: function () {
      let _that = this;

      if (_that.peerItem.term.status == 1) {
        _that.tip = "设备已离线";

        setTimeout(function () {
          _that.tip = "";
        }, 1500);
        return;
      }
      _that.xbjf = 6;
      _that.xbjfPercent = 5;
      setTimeout(function () {
        _that.xbjfPercent = 15;
      }, 500);
      setTimeout(function () {
        _that.xbjfPercent = 90;
      }, 1500);
      setTimeout(function () {
        _that.xbjfPercent = 100;
      }, 2500);
      setTimeout(function () {
        _that.xbjf = 1;
      }, 2800);

      setTimeout(function () {
        _that.$router.push({
          name: "SpeedShare",
          params: { cur_pid: _that.peerid },
        });
      }, 3000);

      _that.miniappStatus([_that.peerid, "xbjf", 1, function (err, data) {}]);
    },
    openXbjfClick: function () {
      let _that = this;
      if (_that.peerItem.term.status == 1) {
        _that.tip = "设备已离线";

        setTimeout(function () {
          _that.tip = "";
        }, 1500);
        return;
      }
      _that.$router.push({
        name: "SpeedShare",
        params: { cur_pid: _that.peerid },
      });
    },
    arrowXbjfClick: function () {
      let _that = this;
      _that.isShowXbjfUninstall = !_that.isShowXbjfUninstall;
      _that.isShowKdtsUninstall = false;
    },
    uninstallXbjsClick: function () {
      let _that = this;
      _that.xbjf = 9;
      _that.isShowXbjfUninstall = false;
      _that.miniappStatus([_that.peerid, "xbjf", 0, function (err, data) {}]);

      _that.xbjfPercent = 5;
      setTimeout(function () {
        _that.xbjfPercent = 15;
      }, 500);
      setTimeout(function () {
        _that.xbjfPercent = 90;
      }, 1500);
      setTimeout(function () {
        _that.xbjfPercent = 100;
      }, 2500);
      setTimeout(function () {
        _that.xbjf = -1;
      }, 2800);
    },

    getMiniappList: function (peerid) {
      let _that = this;
      _that.isLoading = true;
      _that.miniappList([
        peerid,
        function (err, data) {
          _that.isLoading = false;
          if (!err && data && data.rtn == 0) {
            if (!data.kdts) {
              _that.kdts = -1;
            } else {
              _that.kdts = data.kdts;
            }
            if (!data.xbjf) {
              _that.xbjf = -1;
              // console.log("aaa",_that.xbjf);
            } else {
              _that.xbjf = data.xbjf;
              // console.log("bbb",_that.xbjf);
            }

            if (!data.xcbf) {
              _that.xcbf = -1;
            } else {
              _that.xcbf = data.xcbf;
            }
            //
            // this.$forceUpdate();
            // _that.$forceUpdate();
          }
        },
      ]);
    },

    saveNewNameClick: function () {
      let _that = this;
      _that.isEdit = false;

      _that.sendUserlog(["deviceName_edit", ""]);
      if (_that.newName != _that.newName2) {
        let deviceName = _that.newName;
        if (!deviceName) {
          deviceName = "0";
        }
        _that.deviceName([
          _that.unbindItem.peerid,
          deviceName,
          function (err, data) {
            if (data && data.rtn == 0) {
              _that.newName2 = _that.newName;
            }
          },
        ]);
      }
    },
    editNameClick: function () {
      let _that = this;
      _that.isEdit = true;
    },
    visitClick: function () {
      let _that = this;
      if (_that.unbindItem.term.status == 1) {
        return;
      }
      _that.$emit("visitClick", _that.unbindItem);
    },
    changeMinuteToHourMinute: function (str) {
      if (str !== "0" && str !== "" && str !== null) {
        if (str < 60) {
          return str + "分";
        } else if (str % 60 == 0) {
          return str / 60 + "小时";
        } else {
          return parseInt(str / 60) + "小时" + (str % 60) + "分";
        }
      } else {
        return "";
      }
    },
    hideAlertClick: function () {
      let _that = this;
      _that.isShowAlert = false;
    },
    doCacheCleanClick: function () {
      let _that = this;
      _that.$emit("cacheCleanClick", _that.size, _that.switching);
      _that.hideAlertClick();
    },
    sizeClick: function (size) {
      let _that = this;
      _that.size = size;
    },
    hideCacheCleanClick: function () {
      let _that = this;
      _that.hideAlertClick();
    },
    cacheCleanClick: function (settingType) {
      let _that = this;
      _that.isShowAlert = true;

      // 不用校验是否普通模式
      // if (settingType == 5) {
      // 	_that.$emit("cacheCleanClick", null, _that.switching);
      // 	_that.hideAlertClick();
      // } else {
      // }

      if (_that.isCleaningCache) {
        _that.settingType = 6;
        _that.myWidth = "340px";
        _that.myHeight = "220px";
      } else if (settingType == 6) {
        _that.settingType = settingType;
        _that.myWidth = "340px";
        _that.myHeight = "220px";
        _that.$emit("cacheCleanClick", null, _that.switching);

        _that.initCleaning();
      } else {
        _that.settingType = settingType;
        _that.myWidth = "370px";
        _that.myHeight = "290px";
      }
    },
    doUnbindClick: function () {
      //通知父组件
      let _that = this;
      _that.$emit("doUnbindClick");
      _that.$emit("showOrHideSettingTipClick", null, null, "hide");
    },
    unbindClick: function (settingType) {
      let _that = this;
      _that.isShowAlert = true;
      if (settingType == 2 && _that.switching == 1) {
        settingType = 3;
      }
      _that.settingType = settingType;
      _that.myWidth = "370px";
      _that.myHeight = "290px";
    },
    showOrHideSettingTipClick: function () {
      let _that = this;
      _that.$emit("showOrHideSettingTipClick", null, null, "hide");
    },
    drawChart4: function (dateArr, bandwidthArr) {
      let myChart = echarts.init(document.getElementById("chart4"));
      let option;

      option = {
        tooltip: {
          trigger: "axis",
          // axisPointer: {
          //   type: "cross",
          //   label: {
          //     backgroundColor: "#6a7985",
          //   },
          // },
          formatter: "{a}：{c}Mbps<br/>{b}",
        },
        legend: {
          show: false,
        },
        toolbox: {
          feature: {
            saveAsImage: { show: false },
          },
        },
        grid: {
          top: "20%",
          left: "2%",
          right: "0%",
          bottom: "0%",
          containLabel: true,
          show: true,
          // backgroundColor:'#E5E5E5',
          borderColor: "transparent",
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: dateArr,
            axisTick: {
              show: true,
            },
            axisPointer: {
              type: "none", //line或者none
            },
            axisLabel: {
              fontWeight: "normal",
              align: "left",
              verticalAlign: "middle",
              padding: [0, 0, 0, 0],
              color: "transparent",
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "transparent",
              },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            axisPointer: {
              type: "none",
            },
            splitLine: {
              lineStyle: {
                type: "solid",
                color: ["#E6E6E6"],
              },
            },
            axisLabel: {
              fontWeight: "normal",
              color: "rgba(203, 203, 203, 1)",
            },
            splitNumber: 4,
          },
        ],
        series: [
          {
            name: "活跃带宽",
            type: "line",
            stack: "总量",
            // areaStyle: {
            //   color: "#transparent",
            // },
            itemStyle: {
              normal: {
                // color: "#8B61ED",
              },
            },
            lineStyle: {
              color: "#1F5DE3", // 0% 处的颜色
              width: 1,
            },
            emphasis: {
              focus: "series",
              lineStyle: {
                width: 1,
              },
            },
            data: bandwidthArr,
            smooth: true,
            symbol:
              "image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADESURBVHgBVY4/DoJQDMbbPiER/7EaQ2IciVdx5AoewIN4AK/A6AG8hMHFgYTBVUUggO/VV0iMdmjT72t/LYJEdHYXQ38J1HqKSTHgPSufGcTrBjtzNArFgJ8gNDotioQCbxqISQwbNOqEBo+gYWOsJlRCYF82mGlr8wQA54hqJ5pjT5Juje6hOP7y2bykCIVg4JQ9Qe+B4WYHcyY+dJp9FsOI3YeThsr5f1Jr9Z7ViwtKI0O5dw0QXF8MoLqaVas0ibH5ALP4TXlg1ziUAAAAAElFTkSuQmCC",
            showSymbol: false,
            symbolSize: 13,
          },
        ],
      };

      option && myChart.setOption(option);
    },
    drawChart3: function (cacheUsedPercent) {
      let chartDom = document.getElementById("chart3");
      let myChart = echarts.init(chartDom);
      let option;

      option = {
        series: [
          {
            type: "gauge",
            startAngle: 90, //起始角度
            endAngle: 450, //终止角度
            center: ["50%", "50%"],
            progress: {
              show: true,
              width: 3,
              itemStyle: {
                color: "#1F5DE3",
              },
            },
            axisLine: {
              lineStyle: {
                width: 3,
                color: [[1, "#DEE6F8"]],
              },
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
            title: {
              show: false,
            },
            detail: {
              valueAnimation: true,
              formatter: "{value}%",
              fontSize: 12,
              padding: [0, 0, 0, 55], //上右下左
            },
            pointer: {
              show: false,
            },
            data: [
              {
                value: cacheUsedPercent,
              },
            ],
          },
        ],
      };

      option && myChart.setOption(option);
    },
    drawChart2: function (memoryUsedPercent) {
      let chartDom = document.getElementById("chart2");
      let myChart = echarts.init(chartDom);
      let option;

      option = {
        series: [
          {
            type: "gauge",
            startAngle: 90, //起始角度
            endAngle: 450, //终止角度
            center: ["50%", "50%"],
            progress: {
              show: true,
              width: 3,
              itemStyle: {
                color: "#E34E1F",
              },
            },
            axisLine: {
              lineStyle: {
                width: 3,
                color: [[1, "#FCE1DB"]],
              },
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
            title: {
              show: false,
            },
            detail: {
              valueAnimation: true,
              formatter: "{value}%",
              fontSize: 12,
              padding: [0, 0, 0, 55], //上右下左
            },
            pointer: {
              show: false,
            },
            data: [
              {
                value: memoryUsedPercent,
              },
            ],
          },
        ],
      };

      option && myChart.setOption(option);
    },
    drawChart1: function (cpusage) {
      let chartDom = document.getElementById("chart1");
      let myChart = echarts.init(chartDom);
      let option;
      option = {
        series: [
          {
            type: "gauge",
            startAngle: 90, //起始角度
            endAngle: 450, //终止角度
            center: ["50%", "50%"],
            progress: {
              show: true,
              width: 3,
              itemStyle: {
                color: "#E3AC1F",
              },
            },
            axisLine: {
              lineStyle: {
                width: 3,
                color: [[1, "#FCF2DA"]],
              },
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
            title: {
              show: false,
            },
            detail: {
              valueAnimation: true,
              formatter: "{value}%",
              fontSize: 12,
              padding: [0, 0, 10, 55], //上右下左
            },
            pointer: {
              show: false,
            },
            data: [
              {
                value: cpusage,
              },
            ],
          },
        ],
      };

      option && myChart.setOption(option);
    },
    myLimitget: function () {
      let _that = this;
      _that.limitget([
        _that.unbindItem.peerid,
        function (err, data) {
          if (data && data.rtn == 0) {
            // for test
            // data.cacheused = 100;

            if (data.cacheused) {
              _that.cacheused = data.cacheused;
            } else {
              _that.cacheused = 0;
            }
            if (data.switch && data.switch == 1) {
              _that.switching = 1;
            } else {
              _that.switching = 0;
            }

            // 取消收益弹窗
            _that.switching = 1;

            let cachetotal = 0;
            if (data.cachetotal) {
              cachetotal = data.cachetotal;
            }
            let cacheUsedPercent = 0;
            if (cachetotal && _that.cacheused) {
              cacheUsedPercent = parseInt((_that.cacheused / cachetotal) * 100);
            }
            // _that.drawChart3(cacheUsedPercent);

            if (data.cacheleft) {
              _that.cacheleft = data.cacheleft;
            }
          }
        },
      ]);
    },
    initCleaning: function () {
      let _that = this;
      let timestamp = parseInt(new Date().getTime() / 1000);
      _that.$common.localStorage.setItem(
        "jdxb-lastCacheCleanTimestamp",
        timestamp
      );
      _that.$common.localStorage.setItem(
        "jdxb-lastCacheCleanSize",
        _that.cacheused
      );
      _that.renderCacheBtn();
    },
    renderCacheBtn: function () {
      let _that = this;
      let lastCacheCleanTimestamp = _that.$common.localStorage.getItem(
        "jdxb-lastCacheCleanTimestamp"
      );
      lastCacheCleanTimestamp = lastCacheCleanTimestamp
        ? parseInt(lastCacheCleanTimestamp)
        : 0;
      let timestamp = parseInt(new Date().getTime() / 1000);

      let lastCacheCleanSize = _that.$common.localStorage.getItem(
        "jdxb-lastCacheCleanSize"
      );
      lastCacheCleanSize = lastCacheCleanSize
        ? parseInt(lastCacheCleanSize)
        : 0;

      if (
        lastCacheCleanSize == 0 ||
        _that.cacheused == 0 ||
        _that.cacheused / lastCacheCleanSize < 0.8
      ) {
        _that.isCleaningCache = false;
      } else if (timestamp - lastCacheCleanTimestamp < 60 * 30) {
        _that.isCleaningCache = true;
      } else {
        _that.isCleaningCache = false;
      }
    },
  },

  activated() {
    let _that = this;
    _that.getMiniappList(_that.peerid);

    // console.log("111", _that.peerItem);
    _that.isShowKdtsUninstall = false;
    _that.isShowXbjfUninstall = false;
    _that.isShowXcbfUninstall = false;
  },
  mounted() {
    let _that = this;
    _that.myLimitget();
    _that.renderCacheBtn();
    _that.nodeDeviceInfo([
      _that.unbindItem.peerid,
      function (err, data) {
        if (data && data.rtn == 0) {
          if (data.data.province) {
            _that.province = data.data.province;
          }
          if (data.data.online_minu) {
            _that.online_minu = _that.changeMinuteToHourMinute(
              data.data.online_minu
            );
          }
          if (data.data.isp) {
            _that.isp = data.data.isp;
          }
          if (data.data.last_time) {
            _that.last_time = data.data.last_time;
          }
          if (data.data.nat != undefined) {
            _that.nat = data.data.nat;
          }
          // console.log("data.data.name", data.data.name);
          if (data.data.name && data.data.name != "0") {
            _that.newName2 = data.data.name;
            _that.newName = data.data.name;
          }

          let cpusage = 0;
          if (data.data.cpusage) {
            cpusage = data.data.cpusage;
          }
          let mused = 0;
          let mtotal = 0;
          if (data.data.mused) {
            mused = data.data.mused;
          }
          if (data.data.mtotal) {
            mtotal = data.data.mtotal;
          }
          let memoryUsedPercent = 0;
          if (mused && mtotal) {
            memoryUsedPercent = parseInt((mused / mtotal) * 100);
            if (memoryUsedPercent > 40) {
              memoryUsedPercent = parseInt(40 + (memoryUsedPercent - 40) / 2);
            }
          }
          // _that.drawChart1(cpusage);
          // _that.drawChart2(memoryUsedPercent);
        }
      },
    ]);
    _that.deviceBandwidth([
      _that.unbindItem.peerid,
      function (err, data) {
        if (data && data.rtn == 0) {
          let dateArr = [];
          let bandwidthArr = [];
          for (let index = 0; index < data.data.length; index++) {
            dateArr.push(
              data.data[index].date.replace(/-/g, "/").substring(5, 16)
            );
            bandwidthArr.push(data.data[index].bandwidth);
          }
          // _that.drawChart4(dateArr, bandwidthArr);
        }
      },
    ]);
  },
};
</script>

<style scoped lang="less">
.device-setting-tip {
  margin: 0 auto;
  width: 932px;
  height: 478px;
  border: 1px solid #c9d9e4;
  border-radius: 4px;
  background-color: #ffffff;
  .bg {
    background-position: center;
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
  .mixinBg {
    background-position: center;
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }

  .info-title {
    position: relative;
    color: #1c1f28;
    font-size: 14px;
    padding-left: 71px;
    height: 20px;
    line-height: 20px;
  }
  .info-title::before {
    content: "";
    position: absolute;
    left: 14px;
    top: 1px;
    background-image: url("../assets/home/node/device6.svg");
    width: 18px;
    height: 18px;
    cursor: pointer;
    background-position: center;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    box-sizing: border-box;
  }
  .info-title::after {
    content: "";
    position: absolute;
    left: 48px;
    top: 2px;
    width: 16px;
    height: 16px;
    background-image: url("../assets/home/node/device5.svg");
    .mixinBg();
  }
  .info-line {
    border-top: 1px solid #dbdfe7;
    margin-left: 10px;
    margin-right: 10px;
    margin-bottom: 14px;
    height: 1px;
  }

  .back-wrap {
    height: 48px;
    line-height: 48px;
    font-weight: 700;
    font-size: 14px;
    color: #1a1a1a;
    width: 100px;
    cursor: pointer;

    .back-icon {
      display: inline-block;
      margin-left: 24px;
      margin-top: 15px;
      margin-right: 4px;
      vertical-align: top;
      width: 17px;
      height: 17px;
      background-image: url(../assets/setting/back.svg);
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }
  }
  .big-wrap {
    text-align: center;

    .wrap3 {
      display: inline-block;
      padding-top: 1px;
      margin-left: 12px;
      vertical-align: top;
      background-color: #fcfcfc;
      border: 1px solid #eeeeee;
      border-radius: 8px;
      width: 552px;
      height: 414px;
      box-sizing: border-box;
      text-align: left;
      .wrap3-text {
        margin-left: 24px;
        margin-top: 15px;
        font-weight: 600;
        font-size: 16px;
        line-height: 22px;
        color: #1a1a1a;
      }
      .wrap3-text2 {
        margin-top: 24px;
      }
      .wrap3-line {
        margin-top: 8px;
        margin-left: 24px;
        width: 504px;
        height: 1px;
        background-color: #e6e6e6;
      }
      .wrap3-items {
        margin-top: 16px;
        text-align: center;
        .item {
          display: inline-block;
          margin-left: 38px;
          vertical-align: top;
          width: 56px;
          .item-icon {
            margin: 0 auto;
            width: 44px;
            height: 44px;
            background-image: url(../assets/home/node/about1.png);
            background-repeat: no-repeat;
            background-size: 100% 100%;
            box-shadow: 0px 3px 6px rgba(150, 170, 220, 0.2);
            border-radius: 50%;
          }
          .item-icon2 {
            background-image: url(../assets/home/node/about2.png);
          }
          .item-icon3 {
            background-image: url(../assets/home/node/about3.png);
          }
          .item-icon4 {
            background-image: url(../assets/home/node/about4.png);
          }
          .item-icon5 {
            background-image: url(../assets/home/node/about5.png);
          }
          .item-text {
            margin-top: 10px;
            font-size: 14px;
            line-height: 20px;
            color: #666666;
          }
        }
        .item1 {
          margin-left: 0;
        }
        .item-later {
          position: relative;
          .later {
            position: absolute;
            top: -10px;
            left: 28px;
            width: 48px;
            height: 18px;
            background-image: url("../assets/home/node/about6.png");
            background-repeat: no-repeat;
            background-size: 100% 100%;
            .later-text {
              font-weight: 600;
              font-size: 12px;
              line-height: 18px;
              color: #ffffff;
              transform: scale(0.8);
            }
          }
        }
      }
      .app-wrap {
        position: relative;
        margin: 0 auto;
        padding-left: 42px;
        height: 66px;
        line-height: 66px;
        width: 100%;
        box-sizing: border-box;
        .text-icon {
          display: inline-block;
          margin-top: 15px;
          vertical-align: top;
          width: 36px;
          height: 36px;
          background-image: url("../assets/tool/xcbf-icon.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
        }
        .text-icon2 {
          background-image: url("../assets/tool/kdts-icon.png");
        }
        .text-icon3 {
          background-image: url("../assets/tool/byjs-icon.png");
        }
        .text1 {
          display: inline-block;
          margin-left: 16px;
          vertical-align: top;
          font-size: 15px;
          font-weight: 700;
          color: #1a1a1a;
        }
        .text2 {
          display: inline-block;
          margin-left: 24px;
          vertical-align: top;
          font-size: 12px;
          color: #666666;
        }
        .btn {
          position: absolute;
          right: 30px;
          top: 50%;
          transform: translate(0, -50%);
          width: 80px;
          height: 31px;
          line-height: 31px;
          font-size: 12px;
          color: #153f9a;
          text-align: center;
          background-color: #dce7ff;
          border-radius: 20px;
          font-weight: 700;
          cursor: pointer;
        }

        .btn2 {
          position: absolute;
          right: 30px;
          top: 50%;
          transform: translate(0, -50%);
          width: 80px;
          height: 31px;
          line-height: 31px;
          font-size: 12px;
          color: #153f9a;
          text-align: center;
          font-weight: 700;
          cursor: pointer;

          .text {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            z-index: 9;
            white-space: nowrap;
          }
        }
        .btn3 {
          position: absolute;
          right: 128px;
          top: 50%;
          transform: translate(0, -50%);
          width: 80px;
          height: 31px;
          line-height: 31px;
          font-size: 12px;
          color: #ffffff;
          text-align: center;
          background-color: #1f5de3;
          border-radius: 20px;
          font-weight: 700;
          cursor: pointer;

          .icon {
            position: absolute;
            right: 8px;
            top: -2px;
            width: 24px;
            height: 32px;
            background-image: url("../assets/applications/a4.svg");
            .bg();
            background-size: 17px 17px;
          }
          .icon2 {
            top: -1px;
            background-image: url("../assets/applications/a5.svg");
          }
        }
        .btn-open {
          right: 30px;
        }
        .btn-stop {
          padding-left: 14px;
          background-color: #dce7ff;
          color: #153f9a;
          text-align: left;
          box-sizing: border-box;
        }
        .uninstall-btn {
          position: absolute;
          right: 128px;
          bottom: -16px;
          width: 80px;
          height: 31px;
          line-height: 31px;
          font-size: 12px;
          color: #7b88a7;
          text-align: center;
          background-color: #d9deea;
          border-radius: 20px;
          font-weight: 700;
          cursor: pointer;
        }
        .offline-btn {
          background-color: #7c88a1;
          color: #ffffff;
        }
      }

      /*.app-wrap1::before,
			.app-wrap2::before,
			.app-wrap3::before {
				position: absolute;
				left: 0;
				top: 50%;
				transform: translate(0, -50%);
				content: "";
				width: 48px;
				height: 48px;
				background-image: url("../assets/tool/byjs-icon.png");
				.bg();
			}
			.app-wrap2::before {
				background-image: url("../assets/tool/kdts-icon.png");
			}
			.app-wrap3::before {
						background-image: url("../assets/tool/xcbf-icon.png");
			}*/
    }
    .wrap1,
    .wrap2 {
      display: inline-block;
      text-align: left;
    }
    .wrap1 {
      vertical-align: top;
      width: 336px;
      height: 414px;
      box-shadow: 0px 2px 14px rgba(51, 51, 51, 0.2);
      border-radius: 8px;
      background-color: #fcfcfc;

      .wrap1-a {
        position: relative;
        width: 336px;
        box-sizing: border-box;
        padding-top: 36px;

        .info1 {
          position: relative;
          display: inline-block;
          margin-left: 20px;
          img {
            width: 48px;
            height: 48px;
          }
          .status {
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translate(-50%, 0);
            width: 31px;
            height: 14px;
            line-height: 14px;
            background-color: #1f5de3;
            font-size: 12px;
            color: #f0f0f0;
            border-radius: 41px;
            text-align: center;

            div {
              transform: scale(0.75);
            }
          }
          .status-off {
            background-color: #999999;
          }
        }
        .info2 {
          display: inline-block;
          margin-left: 10px;
          vertical-align: top;
          margin-top: 5px;

          .device-name {
            margin-bottom: 4px;
            font-size: 16px;
            color: #1c1f28;
          }
          .device-ip {
            font-size: 12px;
            color: #999999;
          }
        }
        .visit-btn.visit-btn-gray {
          background-color: RGBA(220, 220, 220, 1);
          color: rgba(115, 123, 140, 1);
        }
        .visit-btn.visit-btn-gray:hover {
          cursor: auto;
          opacity: 1;
        }
        .visit-btn.visit-btn-gray::before {
          background-image: url("../assets/home/node/visit_btn_gray.svg");
        }
        .visit-btn {
          position: absolute;
          padding-left: 18px;
          right: 42px;
          top: 46px;
          width: 78px;
          height: 36px;
          line-height: 36px;
          font-size: 12px;
          color: #f5f5f5;
          text-align: center;
          background-color: #1f5de3;
          border-radius: 20px;
          cursor: pointer;
          box-sizing: border-box;
        }
        .visit-btn::before {
          content: "";
          position: absolute;
          left: 18px;
          top: 10px;
          width: 15px;
          height: 15px;
          .mixinBg();
          background-image: url("../assets/home/node/device7.svg");
        }
        .visit-btn:hover {
          cursor: pointer;
          opacity: 0.9;
        }
      }
      .split-line {
        margin: 0 auto;
        margin-top: 24px;
        width: 288px;
        height: 1px;
        background-color: #e6e6e6;
      }
      .split-line2 {
        margin: 0 auto;
        width: 288px;
        height: 1px;
        background-color: #e6e6e6;
      }
      .wrap1-b {
        .text1 {
          position: relative;
          font-size: 14px;
          color: #000000;
          height: 20px;
          line-height: 20px;
          padding-left: 27px;
        }
        .text1::before {
          content: "";
          position: absolute;
          left: 0;
          width: 20px;
          height: 20px;
          background-image: url("../assets/home/node/device8.svg");
          .mixinBg();
        }
        .line {
          margin: 0 auto;
          margin-top: 7px;
          height: 1px;
          width: 288px;
          background-color: #e6e6e6;
        }
        .item-wrap {
          position: relative;
          margin-top: 7px;
          font-size: 12px;

          .item-wrap1 {
            .text2 {
              margin-left: 48px;
              color: #666666;
              height: 32px;
              line-height: 32px;
            }
            .line {
              margin-top: 0;
              margin-top: 8px;
              margin-bottom: 8px;
            }
          }
          .item-wrap2 {
            position: absolute;
            top: 0;
            left: 170px;

            .text3 {
              height: 32px;
              line-height: 32px;
              color: #999999;
            }
            .line2 {
              margin-top: 8px;
              margin-bottom: 8px;
              height: 1px;
            }

            .name-input-wrap {
              position: relative;
              input {
                position: absolute;
                width: 168px;
                top: 4px;
                left: 0;
                height: 24px;
                color: #999999;
                font-size: 12px;
                background-color: transparent;
                cursor: pointer;
              }

              .name-input-focus {
                position: absolute;
                z-index: 2;
                top: 4px;
                left: -14px;
                height: 24px;
                width: 168px;
                border-radius: 58px;
                background-color: #f5f5f5;
                padding-left: 14px;
                box-sizing: border-box;
                border: 1px solid #f1f1f1;
                font-size: 12px;
                color: #666666;
              }
            }

            .edit-icon::before {
              position: absolute;
              content: "";
              left: 0;
              top: 7px;
              width: 17px;
              height: 17px;
              background-image: url("../assets/home/node/device13.svg");
              background-position: center;
              background-repeat: no-repeat;
              background-size: 100% 100%;
            }
            .edit-icon2::before {
              position: absolute;
              content: "";
              right: -20px;
              top: 7px;
              width: 17px;
              height: 17px;
              background-image: url("../assets/home/node/device13.svg");
              background-position: center;
              background-repeat: no-repeat;
              background-size: 100% 100%;
            }
          }
        }
      }
      .my-unbind-btn {
        margin: 0 auto;
        margin-top: 16px;
        width: 160px;
        height: 42px;
        line-height: 42px;
        color: #666666;
        font-size: 14px;
        text-align: center;
        border: 1px solid #e6e6e6;
        cursor: pointer;
        background-color: #f5f5f5;
        border: 1px solid #e6e6e6;
        box-shadow: 0px 8px 22px rgba(194, 194, 194, 0.1);
        border-radius: 24px;
      }
      .my-unbind-btn:hover {
        background-color: #1f5de3;
        color: #f5f5f5;
      }
    }

    .wrap2 {
      padding-left: 14px;
      padding-right: 14px;
      vertical-align: top;
      width: 580px;
      box-sizing: border-box;

      .title-text {
        position: relative;
        padding-left: 27px;
        font-size: 14px;
        color: #000000;
        height: 20px;
        line-height: 20px;
      }
      .title-text::before {
        content: "";
        position: absolute;
        top: 0px;
        left: 0;
        width: 20px;
        height: 20px;
        .mixinBg();
        background-position: left center;
        background-image: url("../assets/home/node/device9.svg");
      }
      .title-text2::before {
        top: 0;
        background-image: url("../assets/home/node/device10.svg");
      }
      .line {
        margin-top: 7px;
        height: 1px;
        background-color: #e6e6e6;
      }

      .wrap2-a.wrap2-a-offline {
        background-image: url(../assets/home/node/offline_bg.png);
        background-size: 100% 100%;
        height: 460px;
        .offline {
          width: 100%;
          height: 400px;
          overflow: hidden;
          .offline_title {
            color: rgba(26, 26, 26, 1);
            font-size: 14px;
            font-weight: bolder;
            margin-top: 80px;
            text-align: center;
          }
          .offline_icon {
            width: 305px;
            height: 170px;
            margin: 0 auto;
            margin-top: 35px;
            background-image: url(../assets/home/node/offline_icon.png);
            background-size: 100% 100%;
          }
        }
      }

      .wrap2-a {
        padding-left: 14px;
        padding-right: 14px;
        padding-top: 14px;
        box-shadow: 0 2px 8px 0 rgba(178, 187, 193, 0.45);
        border-radius: 3px;
        background-color: #ffffff;

        .echarts-wrap {
          position: relative;
          height: 230px;
          text-align: center;
          margin-left: 20px;
          .bg,
          .bg2,
          .bg3 {
            position: absolute;
            left: 0;
            top: 0;
            width: 160px;
            height: 160px;
            div {
              margin-left: 20px;
              margin-top: 20px;
              width: 120px;
              height: 120px;
              border-radius: 50%;
              background-color: #fffcf3;
            }
          }
          .bg2 {
            left: 160px;
            div {
              background-color: #fff5f5;
            }
          }
          .bg3 {
            left: 320px;
            div {
              background-color: #f8f9fb;
            }
          }
          .content-text1 {
            position: absolute;
            top: 40%;
            left: 50%;
            font-size: 14px;
            color: #1a1a1a;
            transform: translate(-50%, 0);
          }
          .content-text2 {
            position: absolute;
            top: 95px;
            left: 45px;
            font-size: 12px;
            color: #1a1a1a;
          }

          .chart-wrap1 {
            position: absolute;
            top: 0;
            left: 0px;
            z-index: 2;
          }
          .chart-wrap2 {
            position: absolute;
            top: 0;
            left: 160px;
            z-index: 2;
          }
          .chart-wrap3 {
            position: absolute;
            top: 0;
            left: 320px;
            z-index: 2;
          }
          .chart-text {
            position: absolute;
            width: 484px;
            text-align: center;
            top: 190px;
            font-size: 12px;
            color: #666666;
            height: 20px;
            line-height: 20px;
            div {
              display: inline-block;
            }
            .text1 {
              position: relative;
              padding-left: 14px;
            }
            .text1::before {
              content: "";
              position: absolute;
              top: 6px;
              left: 0;
              width: 7px;
              height: 7px;
              border-radius: 50%;
              background-color: #a0a6b6;
            }
            .text1::before {
              background-color: #1f5de3;
            }
            .text3 {
              position: relative;
              margin-left: 31px;
              padding-left: 34px;
              color: #999999;
              width: 95px;
              height: 26px;
              line-height: 26px;
              background-color: #e6e6e6;
              border-radius: 20px;
              box-sizing: border-box;

              text-align: left;
              font-size: 12px;
            }
            .text3::before {
              content: "";
              position: absolute;
              top: 4px;
              left: 14px;
              width: 17px;
              height: 17px;
              background-image: url("../assets/home/node/device14.svg");
              background-size: 100% 100%;
              background-repeat: no-repeat;
              background-position: left center;
            }
            .text3:hover {
              cursor: pointer;
              background-color: #1f5de3;
              color: #ffffff;
            }
            .text3:hover::before {
              background-image: url("../assets/home/node/device14_white.svg");
            }
          }
        }
      }
      .wrap2-b {
        margin-top: 14px;
        padding-left: 14px;
        padding-right: 14px;
        padding-top: 14px;
        box-shadow: 0 2px 8px 0 rgba(178, 187, 193, 0.45);
        border-radius: 3px;
        background-color: #ffffff;
      }
    }
  }

  .close-btn {
    background-image: url(../assets/common/close4.svg);
    background-size: 100% 100%;
    width: 20px;
    height: 20px;
    position: absolute;
    right: 15px;
    top: 15px;
    cursor: pointer;
  }
  .close-btn:hover {
    opacity: 0.8;
  }
  .title {
    margin-top: 14px;
    text-align: center;
    font-weight: 700;
    font-size: 17px;
    line-height: 20px;
    color: #1a1a1a;
  }

  .unbind-wrap {
    padding-top: 1px;

    img {
      display: block;
      margin: 0 auto;
      margin-top: 26px;
      width: 58px;
      height: 58px;
    }

    .text-wrap {
      margin-bottom: 36px;

      .text1 {
        margin: 0 auto;
        margin-top: 20px;
        text-align: center;
        font-size: 15px;
        color: #666666;
        line-height: 22px;

        span {
          font-weight: 700;
        }
      }
    }

    .btn1 {
      display: inline-block;
      margin-left: 42px;
      width: 130px;
      height: 41px;
      line-height: 41px;
      background-color: #dc2d2d;
      border-radius: 102px;
      font-weight: 700;
      text-align: center;
      color: #ffffff;
      cursor: pointer;
    }
    .btn1:hover {
      opacity: 0.9;
    }
    .btn2 {
      display: inline-block;
      margin-left: 20px;
      width: 130px;
      height: 41px;
      line-height: 41px;
      background-color: #1f5de3;
      border-radius: 102px;
      text-align: center;
      color: #ffffff;
      font-weight: 700;
      cursor: pointer;
    }
    .btn2:hover {
      opacity: 0.9;
    }
  }

  .cache-clean-wrap {
    img {
      display: block;
      margin: 0 auto;
      margin-top: 26px;
      width: 58px;
      height: 58px;
    }
    .text-wrap {
      margin-top: 20px;
      margin-bottom: 36px;

      .text1 {
        margin: 0 auto;
        text-align: center;
        font-size: 15px;
        color: #666666;
        line-height: 22px;
      }
    }

    .btn1 {
      margin: 0 auto;
      width: 187px;
      height: 41px;
      line-height: 41px;
      background-color: #1f5de3;
      border-radius: 102px;
      text-align: center;
      color: #ffffff;
      font-weight: 700;
      font-size: 14px;
      cursor: pointer;
    }

    .clean-btns {
      text-align: center;

      .clean-btn-sure {
        margin: 0 auto;
        border-radius: 20px;
        width: 130px;
        height: 40px;
        line-height: 40px;
        font-size: 14px;
        color: #fefefe;
        text-align: center;
        background-color: #1f5de3;
        display: inline-block;
        vertical-align: top;
      }
      .clean-btn-sure:hover {
        opacity: 0.8;
        cursor: pointer;
      }

      .clean-btn-cancel {
        margin: 0 auto;
        border-radius: 20px;
        width: 130px;
        height: 40px;
        line-height: 40px;
        margin-left: 15px;
        font-size: 14px;
        color: rgba(153, 153, 153, 1);
        text-align: center;
        background-color: rgba(230, 230, 230, 1);
        display: inline-block;
        vertical-align: top;
      }
      .clean-btn-cancel:hover {
        opacity: 0.8;
        cursor: pointer;
      }
    }
  }

  .do-cache-clean-wrap {
    text-align: center;
    .text-wrap {
      margin: 0 auto;
      margin-top: 26px;
      padding-top: 16px;
      background-color: rgba(240, 175, 45, 0.08);
      width: 328px;
      height: 68px;
      box-sizing: border-box;
      text-align: left;

      .img-wrap {
        display: inline-block;
        margin-left: 14px;
        vertical-align: top;
        img {
          width: 36px;
          height: 36px;
        }
      }
      .text1 {
        display: inline-block;
        margin-left: 10px;
        width: 255px;
        font-size: 14px;
        color: #666666;
      }
    }
    .cache-clean-options {
      margin-top: 20px;
      div {
        display: inline-block;
        width: 82px;
        height: 27px;
        line-height: 27px;
        border-radius: 2px;
        border: 1px solid #cccccc;
        font-size: 14px;
        color: #666666;
        cursor: pointer;
        box-sizing: border-box;
      }
      .text2 {
        margin-left: 10px;
        margin-right: 10px;
      }
      .active {
        background-color: #f9c357;
        color: #f5f5f5;
        font-weight: 700;
        border: 1px solid #f9c357;
      }
    }

    .clear-cache-btn {
      margin: 0 auto;
      margin-top: 30px;
      width: 187px;
      height: 41px;
      line-height: 41px;
      border-radius: 102px;
      background-color: #1f5de3;
      font-size: 14px;
      font-weight: 700;
      color: #ffffff;
    }
    .clear-cache-btn:hover {
      // background-color: #1f5de3;
      cursor: pointer;
      opacity: 0.9;
    }

    .cleaning-tips {
      margin-top: 40px;
      text-align: center;
      font-weight: 700;
      font-size: 17px;
      line-height: 20px;
      color: #1a1a1a;
    }

    .cleaning-sub-tips {
      margin-top: 30px;
      margin-bottom: -15px;
      text-align: center;
      font-size: 13px;
      line-height: 20px;
      color: #888888;
    }
  }
}
</style>
